import React from "react";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import trans from "../../../utils";
import { Tag } from "antd";
import { formatDate } from "../../../JsHelpers/DateFormat";

export default function InspectionRequestInformation({
  values = {},
  statusColors,
}) {
  const getValue = (value, defaultValue = "-----") =>
    value ? value : defaultValue;

  const { discipline = "", status = "", submitted_at = "" } = values;

  const formattedSubmittedAt = submitted_at
    ? formatDate(submitted_at).formattedDate
    : "-----";

  return (
    <div>
      <p className="fs-16 fw-700 brand-700 text-uppercase">
        {trans("Inspection Request Details")}
      </p>
      <div className="row">
        <div className="col-lg-6">
          <div className="display-border">
            <PopupBodyItem
              title={trans("Discipline")}
              item={trans(getValue(discipline))}
            />
            <PopupBodyItem
              title={trans("Zone")}
              item={getValue(values?.zone?.name)}
            />
            <PopupBodyItem
              title={trans("Project")}
              item={getValue(values?.project?.name)}
            />
            <PopupBodyItem
              title={trans("Submitted By")}
              item={getValue(values?.submittedBy?.name)}
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="display-border">
            {/* ✅ UPDATED - Level from relation */}
            <PopupBodyItem
              title={trans("Level")}
              item={getValue(values?.level?.name)}
            />

            {/* ✅ NEW - Room field */}
            <PopupBodyItem
              title={trans("Room")}
              item={getValue(values?.room?.name)}
            />

            <PopupBodyItem
              title={trans("Form")}
              item={getValue(values?.form?.name)}
            />
            <PopupBodyItem
              title={trans("Status")}
              item={getValue(
                <Tag color={statusColors[status] || "default"}>
                  {trans(status)}
                </Tag>
              )}
            />
            <PopupBodyItem
              title={trans("Submitted At")}
              item={trans(getValue(formattedSubmittedAt))}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
